const r = (e) => /\.$/.test(e) ? e : e + ".";
export {
  r as addPeriodToString
};
